<template>
    <div v-if="loadingSpinnerFlag" class="bg-[#252526] z-50 fixed w-full h-full">
        <div class="w-10 h-10 rounded-full animate-spin border-solid border-4 border-[#DA4167] border-t-transparent absolute top-[40%] left-[45%] ml-[-20px]"></div>
    </div>
    <div v-else class="flex justify-center w-full">
        <div class="w-[90%]">
            <div class="w-full flex justify-center">
                <div 
                    :class="{
                        'w-[93%]' : screenWidth > 1500,
                        'w-[100%] px-[20px]' : screenWidth < 1500,
                    }" 
                    class="mt-[15px]"
                >
                    <div>
                        <div class="main__first-line first-line">
                            <div class="first-line__item" >
                                <h3 class="first-line__title">Гравці</h3>
                                <div class="first-line__value">
                                    <span></span> <span>{{ allPlayersCount }}</span>
                                </div>
                            </div>
                            <div class="first-line__item relative" >
                                <h3 class="first-line__title">Тренування</h3>
                                <h5 class="text-[10px] absolute left-[50%] translate-x-[-50%] mt-[-3px]">В цьому сезоні</h5>
                                <div class="first-line__value">
                                    <span></span> <span>{{ trainingCount }}</span>
                                </div>
                            </div>
                            <div class="first-line__item" >
                                <h3 class="first-line__title">Відвідуваність</h3>
                                <div class="first-line__value">
                                    <span></span> <span>{{ averageAttendance?.toFixed(2) }}</span>
                                </div>
                            </div>
                            <div class="first-line__item relative" >
                                <h3 class="first-line__title">Матчі</h3>
                                <h5 class="text-[10px] absolute left-[50%] translate-x-[-50%] mt-[-3px] font-bold">{{ winratePercent }}% виграних</h5>
                                <div class="first-line__value">
                                    <span></span> <span>{{ matchesCount }}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-[100%] flex justify-center">
                        <WeekTrainerCycle />
                    </div>

                    <div class="flex justify-between">
                        <div class="w-[31.5%] mt-[20px]">
                            <div class="bg-[#2E2F2F] border-[1px] border-[#383939] rounded-[13px] px-[10px] pt-[6px] h-full">
                                <div class=" border-[#C59014] pb-[10px]">
                                    <div class="text-[#C59014] text-[20px] font-bold text-center">Турнірна таблиця</div>
                                </div>
                                <div>
                                    <table class="w-full mt-[15px] mb-[10px]">
                                        <thead class="border-b-[1px] border-[#C59014]">
                                            <tr class="text-[#BD9135] text-[14px] font-bold">
                                                <th class="w-[40%] text-start pb-[10px]">Команда</th>
                                                <th class="w-[15%] text-center pb-[10px]">І</th>
                                                <th class="w-[15%] text-center pb-[10px]">В</th>
                                                <th class="w-[15%] text-center pb-[10px]">Н</th>
                                                <th class="w-[15%] text-center pb-[10px]">П</th>
                                                <th class="w-[15%] text-center pb-[10px] pr-[5px]">О</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-if="ratingTable.length" v-for="row in ratingTable" class="text-[#BD9135] text-[14px] odd:bg-[#3A3B3B] even:bg-transparent">
                                                <td class="w-[40%] text-start py-[6px] pl-[5px] truncate">{{ row[0] }}</td>
                                                <td class="w-[15%] text-center">{{ row[1] }}</td>
                                                <td class="w-[15%] text-center">{{ row[2] }}</td>
                                                <td class="w-[15%] text-center">{{ row[3] }}</td>
                                                <td class="w-[15%] text-center">{{ row[4] }}</td>
                                                <td class="w-[15%] text-center pr-[5px]">{{ row[5] }}</td>
                                            </tr>
                                            <tr v-else class="text-[#BD9135] text-[14px]">
                                                <td colspan="6" class="w-full text-center py-[10px] opacity-60">Відсутні дані</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="w-[20.5%] flex-col flex justify-between gap-[10px] mt-[20px]">
                            <div class="w-full h-full bg-[#2E2F2F] border-[1px] border-[#383939] rounded-[13px]">
                                <div class="text-[#C59014] text-[16px] font-bold mb-[15px] mt-[10px] ml-[15px]">
                                    Направленості за тиждень
                                </div>
                                <div>
                                    <TimePieChart :data="currentWeekTrainingsDirection" />
                                </div>
                            </div>
                            <div class="w-full h-full bg-[#2E2F2F] border-[1px] border-[#383939] rounded-[13px]">
                                <div class="text-[#C59014] text-[16px] font-bold mb-[15px] mt-[10px] ml-[15px]">
                                    Направленості за місяць
                                </div>
                                <div>
                                    <TimePieChart :data="currentMonthTrainingsDirection" />
                                </div>
                            </div>
                        </div>
                        <div ref="chartBlock" class="w-[45%] mt-[20px] pb-[6px] bg-[#2E2F2F] border-[1px] border-[#383939] rounded-[13px]">
                            <div class="text-[#C59014] text-[20px] font-bold mb-[15px] mt-[10px] ml-[15px]">
                                GPS дані
                            </div>
                            <MultiLineChart 
                                class="mt-[30px]"
                                :key="chartKey"
                                :totalDistance="totalDistance"
                                :averageSpeed="averageSpeed"
                                :speedZone="speedZone"
                                :sprintCount="sprintCount"
                                :speedDistance="speedDistance"
                                :chartMatchesDates="chartMatchesDates"
                            />
                        </div>
                    </div>
                    

                    <div class="flex justify-between mt-[20px]">
                        <div class="trainings-block h-[293px] w-[32%] bg-[#2E2F2F] border-[1px] border-[#383939] rounded-[13px]">
                            <div class="text-[#C59014] relative left-[4px] text-[16px] font-bold text-start mt-[10px] ml-[15px]">
                                НАСТУПНІ ТРЕНУВАННЯ
                            </div>
                            <div class="mt-[5px] h-[248px] overflow-auto px-[10px] message-box">
                                <div v-for="training in fiveNextTrainings" class="w-full flex h-[24px] items-center rounded-[4px] border-[1px] border-green-400 mb-[9px]">
                                    <div class="h-full rounded-l-[4px] bg-green-400 w-[5px]"></div>
                                    <div class="px-[14px] w-full flex text-[#BD9135] align-middle">
                                        <div class="w-[10%] align-middle text-[0.9em] ">
                                            {{ getWeekDayShortNameByDate(training.date) }}.
                                        </div>
                                        <div class="w-[25%] text-[0.9em] truncate text-start font-semibold align-middle">
                                            {{ training.date.split('T')[0].split('-').reverse().join('.') }}
                                        </div>
                                        <div class="w-[20%] text-[0.9em] text-center align-middle">
                                            {{ training.start_time }}
                                        </div>
                                        <div class="w-[30%] text-[0.9em] truncate text-center align-middle">
                                            {{ training.location_label }}
                                        </div>
                                        <div class="w-[15%] font-bold text-[0.9em] truncate text-end align-middle">
                                            {{ training.group_label }}
                                        </div>
                                    </div>
                                </div>
    
                                <div v-if="fiveNextTrainings.length < 5" v-for="training in 5 - fiveNextTrainings.length" class="w-full flex h-[24px] items-center rounded-[4px] border-[1px] border-[#4E5568] mb-[9.2px]">
                                <div class="h-full rounded-l-[4px] bg-gray-400 w-[5px]"></div>
                                    <div class="px-[d] w-full flex text-[#BD9135] align-middle">
                                        <div class="w-full text-[14px] truncate opacity-60 text-center align-middle">
                                            Відсутнє заплановане тренування
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="trainings-block h-[293px] w-[32%] bg-[#2E2F2F] border-[1px] border-[#383939] rounded-[13px]">
                            <div class="text-[#C59014] text-[16px] relative left-[4px] font-bold text-start mt-[10px] ml-[15px]">
                                НАСТУПНІ МАТЧІ
                            </div>
                            <div class="mt-[5px] h-[268px] overflow-auto px-[10px] message-box">
                                <div v-for="matchId in futureMatchesMax" class="w-full flex h-[24px] items-center rounded-[4px] border-[1px] border-green-400 mb-[9px]">
                                    <div class="h-full rounded-l-[4px] bg-green-400 w-[5px]"></div>
                                    <div class="pl-[14px] w-full flex text-[#BD9135] align-middle">
                                        <div class="w-[10%] align-middle text-[0.9em] ">
                                            {{ getWeekDayShortNameByDate(trainerFutureMatches[matchId].date) }}.
                                        </div>
                                        <div class="w-[25%] text-[0.9em] truncate text-start font-semibold align-middle">
                                            {{ trainerFutureMatches[matchId].date.split('T')[0].split('-').reverse().join('.') }}
                                        </div>
                                        <div class="w-[65%] text-[0.9em] text-center align-middle">
                                            <span class="truncate">
                                                {{ trainerFutureMatches[matchId].firstTeamName.length > 12 ? trainerFutureMatches[matchId].firstTeamName.slice(0, 12) + '...' : trainerFutureMatches[matchId].firstTeamName }}
                                            </span> 
                                            -
                                            <span class="truncate">
                                                {{ trainerFutureMatches[matchId].secondTeamName.length > 12 ? trainerFutureMatches[matchId].secondTeamName.slice(0, 12) + '...' : trainerFutureMatches[matchId].secondTeamName }}
                                            </span> 
                                        </div>
                                    </div>
                                </div>
    
                                <div v-if="futureMatchesMax < 5" v-for="training in 5 - futureMatchesMax" class="w-full flex h-[24px] items-center rounded-[4px] border-[1px] border-[#4E5568] mb-[9.2px]">
                                <div class="h-full rounded-l-[4px] bg-gray-400 w-[5px]"></div>
                                    <div class="px-[d] w-full flex text-[#BD9135] align-middle">
                                        <div class="w-full text-[14px] truncate opacity-60 text-center align-middle">
                                            Відсутнє заплановане тренування
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="trainings-block h-[293px] w-[32%] bg-[#2E2F2F] border-[1px] border-[#383939] rounded-[13px]">
                            <div class="text-[#C59014] relative left-[4px] text-[16px] font-bold text-start mt-[10px] ml-[15px]">
                                ПОПЕРЕДНІ МАТЧІ
                            </div>
                            <div class="mt-[5px] h-[268px] overflow-auto px-[10px] message-box">
                                <div v-for="matchId in pastMatchesMax" class="w-full flex h-[24px] items-center rounded-[4px] border-[1px] border-green-400 mb-[9px]">
                                    <div class="h-full rounded-l-[4px] bg-green-400 w-[5px]"></div>
                                    <div class="pl-[14px] w-full flex text-[#BD9135] align-middle">
                                        <div class="w-[10%] align-middle text-[0.9em] ">
                                            {{ getWeekDayShortNameByDate(trainerPastMatches[matchId].date) }}.
                                        </div>
                                        <div class="w-[25%] text-[0.9em] truncate text-start font-semibold align-middle">
                                            {{ trainerPastMatches[matchId].date.split('T')[0].split('-').reverse().join('.') }}
                                        </div>
                                        <div class="w-[65%] text-[0.9em] text-center align-middle truncate">
                                            <span class="truncate">
                                                {{ trainerPastMatches[matchId].firstTeamName.length > 12 ? trainerPastMatches[matchId].firstTeamName.slice(0, 12) + '...' : trainerPastMatches[matchId].firstTeamName }}
                                            </span> 
                                            -
                                            <span class="truncate">
                                                {{ trainerPastMatches[matchId].secondTeamName.length > 12 ? trainerPastMatches[matchId].secondTeamName.slice(0, 12) + '...' : trainerPastMatches[matchId].secondTeamName }}
                                            </span> 
                                        </div>
                                    </div>
                                </div>
    
                                <div v-if="pastMatchesMax < 5" v-for="training in 5 - pastMatchesMax" class="w-full flex h-[24px] items-center rounded-[4px] border-[1px] border-[#4E5568] mb-[9.2px]">
                                <div class="h-full rounded-l-[4px] bg-gray-400 w-[5px]"></div>
                                    <div class="px-[d] w-full flex text-[#BD9135] align-middle">
                                        <div class="w-full text-[14px] truncate opacity-60 text-center align-middle">
                                            Відсутнє заплановане тренування
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { onMounted, ref } from 'vue'
    import { useMainStore } from '../stores/mainStore'
    import { useRouter } from 'vue-router'
    import { getAllIncomesByGroupInYear, getCurrentMonthTrainingsDirection, getCurrentWeekTrainingsDirection, parseTeamScoreTable, getAllCompletedTrainingsByStudentId, getTrainerTrainingsCountInCurrentSeason, getGroupsAttendanceByYearAndMonth, getPlayerTimeAndMatchCount, getStudentsByGroupIdRequest, getGpsReportByMatchId, getAllMatchesByTrainerGroups, getTrainerCompletedTrainingsByYear } from '@/desktopApp/services/apiRequests'

    import BarChart from '../components/MainComponents/BarChart.vue'
    import OneLine from '../components/MainComponents/OneLine.vue'
    import LineChart from '../components/MainComponents/LineChart.vue'
    import PercentLine from '../components/MainComponents/PercentLine.vue'
    import MultiLineChart from '../components/MainComponents/MultiLineChart.vue'
    import TimePieChart from '../components/MainComponents/TimePieChart.vue'
    import WeekTrainerCycle from '../components/WeekTrainerCycle.vue'

    function isDateGreaterThanNow(dateString) {
        const inputDate = new Date(dateString); // создаем объект Date из строки 
        const currentDate = new Date(); // текущая дата и время

        // Сравниваем только дату без времени
        inputDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        return inputDate > currentDate; // возвращаем true, если дата больше текущей
    }

    export default {
        name: 'main-view',

        setup() {
            const store = useMainStore()
            const router = useRouter()
            const screenWidth = ref(window.innerWidth)

            const loadingSpinnerFlag = ref(true)

            const incomesByGroupsYear = ref(new Date().getFullYear())
            const incomesByGroupsMonth = ref(new Date().getMonth())
            const filteredIncomesByYear = ref([])
            const dataForCurrentMonthGroupsIncomes = ref({})

            const groupAttendanceYear = ref(new Date().getFullYear())
            const groupAttendanceMonth = ref(new Date().getMonth())
            const groupAttendanceChartData = ref([])

            const completedTrainingsYear = ref(new Date().getFullYear())
            const completedTrainingsMonth = ref(new Date().getMonth())
            const completedTrainingsFlag = ref(false)

            const dataForYearGroupsIncomes = ref({ data: [], labels: [] })

            const chartBlock = ref(null)
            const chartKey = ref(1)

            const trainerAllCompletedTrainings = ref({
                    data: [1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
                    labels: ['січ', 'лют', 'бер', 'кві', 'тра', 'чер', 'лип', 'сер', 'вер', 'жов', 'лис', 'гру'],
                })

            const logout = () => {
                localStorage.removeItem('access_token')
                localStorage.removeItem('refresh_token')
                router.go()
            }

            const formatNumber = (number) => {
                const parts = number.toFixed(2).toString().split(".");
                
                const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                
                const formattedNumber = formattedInteger + "." + parts[1];
                
                return formattedNumber;
            }

            const filterIncomesByTrainerGroups = (incomes) => {
                const trainerGroupsIds = store.trainer_groups.map(group => group.group_id)
                const filteredIncomes = []

                for (let i = 0; i < incomes.length; i++) {
                    filteredIncomes.push(incomes[i])
                    filteredIncomes[filteredIncomes.length - 1].groups = incomes[i].groups.filter(group => trainerGroupsIds.includes(group.group_id)) 
                }

                return filteredIncomes
            }

            const generateDataForYearGroupsIncomes = (incomes) => {
                const data = []
                const labels = []

                for (let i = 0; i < 12; i++) {
                    const currentMonth = i > 9 ? `${i + 1}` : `0${i + 1}`
                    const currentIncome = incomes.find(income => income.date_formatted === `${currentMonth}.${incomesByGroupsYear.value}`)
                    if (currentIncome) {
                        data.push(currentIncome.groups.reduce((acc, group) => acc + group.all_incomes, 0))
                    } else {
                        data.push(0)
                    }
                }

                return { data, labels: ['січ', 'лют', 'бер', 'кві', 'тра', 'чер', 'лип', 'сер', 'вер', 'жов', 'лис', 'гру'] }
            }

            const generateDataForCurrentMonthGroupsIncomes = (incomes, currentMonth) => {
                currentMonth = currentMonth > 9 ? `${currentMonth + 1}` : `0${currentMonth + 1}`
                return incomes.find(income => income.date_formatted === `${currentMonth}.${incomesByGroupsYear.value}`)
            }

            const updateCompletedTrainings = async () => {
                completedTrainingsFlag.value = false
                const trainings = await getTrainerCompletedTrainingsByYear(completedTrainingsYear.value, store.trainer.trainer_id)
                trainerAllCompletedTrainings.value.data = trainings.data
                completedTrainingsFlag.value = true
            }

            const getWeekDayShortNameByDate = (date) => {
                const weekDays = ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
                const dateObj = new Date(date)
                return weekDays[dateObj.getDay()]
            }

            const allTrainerMatches = ref([])

            const trainerFutureMatches = ref([])
            const trainerPastMatches = ref([])

            const futureMatchesMax = ref(0)
            const pastMatchesMax = ref(0)

            const matchGpsReports = ref([])

            let totalDistance = []; // Загальна дистанція 
            let averageSpeed = []; // Середня швидкість за матч
            let speedZone = []; // Швидкісна зона 
            let sprintCount = []; // Кількість спринтів 
            let speedDistance = []; // Швидкісний метраж 

            const chartMatchesDates = ref([])

            const allPlayersCount = ref(0)
            const allTrainerPlayers = ref([])
            const averageAttendance = ref(0)
            const matchesCount = ref(0)
            const winratePercent = ref(0)
            const trainingCount = ref(0)

            const getAttendanceCoeff = async (student_id) => {
                const trainingsRes = await getAllCompletedTrainingsByStudentId(student_id)

                let percentTrainingsAttended = trainingsRes.trainings_attended.length * 100 / (trainingsRes.trainings_attended.length + trainingsRes.missed_trainings.length)
                percentTrainingsAttended = percentTrainingsAttended ? percentTrainingsAttended : 0

                return percentTrainingsAttended.toFixed(2)
            }

            const ratingTable = ref([])
            const currentMonthTrainingsDirection = ref([])
            const currentWeekTrainingsDirection = ref([])

            const fiveNextTrainings = ref([])

            onMounted(async () => {
                await store.getTrainerData()
                await store.getStudentBalanceData()
                await store.getServiceBalanceData()
                await store.getTrainerGroups()
                await store.getAllTrainerPlanedTrainings()
                await store.getTrainerRealIncomes()

                const groupAttendanceRes = await getGroupsAttendanceByYearAndMonth(groupAttendanceYear.value, groupAttendanceMonth.value)
                groupAttendanceChartData.value = groupAttendanceRes.data.filter(group => store.trainer_groups.map(group => group.group_id).includes(group.group_id))

                const incomesByGroupsReq = await getAllIncomesByGroupInYear(incomesByGroupsYear.value)
                filteredIncomesByYear.value = filterIncomesByTrainerGroups(incomesByGroupsReq.data)

                // dataForYearGroupsIncomes.value = generateDataForYearGroupsIncomes(filteredIncomesByYear.value)

                // dataForCurrentMonthGroupsIncomes.value = generateDataForCurrentMonthGroupsIncomes(filteredIncomesByYear.value, incomesByGroupsMonth.value)
                
                await updateCompletedTrainings()
                
                allTrainerMatches.value = await getAllMatchesByTrainerGroups(store.trainer.trainer_id)
                console.log('allTrainerMatches.value ------> ', allTrainerMatches.value)

                trainerFutureMatches.value = allTrainerMatches.value.filter(match => isDateGreaterThanNow(match.date))
                trainerPastMatches.value = allTrainerMatches.value.filter(match => !isDateGreaterThanNow(match.date))

                console.log('trainerFutureMatches.value ------> ', trainerFutureMatches.value)
                console.log('trainerPastMatches.value ------> ', trainerPastMatches.value)

                futureMatchesMax.value = trainerFutureMatches.value.length > 5 ? 5 : trainerFutureMatches.value.length > 0 ? trainerFutureMatches.value.length : 0
                pastMatchesMax.value = trainerPastMatches.value.length > 5 ? 5 : trainerPastMatches.value.length > 0 ? trainerPastMatches.value.length : 0

                allTrainerMatches.value.reverse()

                ratingTable.value = (await parseTeamScoreTable(store.trainer_groups[0]?.name?.split(' ')[1]))?.slice(1) || []

                //костыль
                for (let i = 0; i < 5; i++) {
                    const gpsReport = await getGpsReportByMatchId(allTrainerMatches.value[i]?.match_report_id)

                    console.log('gpsReport -----> ', gpsReport)
                    if (gpsReport?.gps_report) {
                        totalDistance.push(+gpsReport.gps_report.average_points_list[0].toFixed(2))
                        averageSpeed.push(+gpsReport.gps_report.average_points_list[2].toFixed(2))
                        speedZone.push(+gpsReport.gps_report.average_points_list[6] ? +gpsReport.gps_report.average_points_list[6].toFixed(2) : 0)
                        sprintCount.push(+gpsReport.gps_report.average_points_list[7] ? +gpsReport.gps_report.average_points_list[7].toFixed(2) : 0)
                        speedDistance.push(+gpsReport.gps_report.average_points_list[3].toFixed(2))
                    } else {
                        totalDistance.push(0)
                        averageSpeed.push(0)
                        speedZone.push(0)
                        sprintCount.push(0)
                        speedDistance.push(0)
                    }

                    chartMatchesDates.value.push(allTrainerMatches.value[i]?.date.split('T')[0].split('-').reverse().join('.'))

                    console.log('chartMatchesDates ++++++', chartMatchesDates.value)
                }

                if (store.trainer_groups[0]?.group_id == undefined) {
                    allPlayersCount.value = 0
                    allTrainerPlayers.value = []
                } else {
                    const playersRes = await getStudentsByGroupIdRequest(store.trainer_groups[0]?.group_id)
                    console.log('playersRes --------> ', playersRes)
                    allPlayersCount.value = playersRes.data.length
                    allTrainerPlayers.value = playersRes.data
                }

                const matchesRes = await getAllMatchesByTrainerGroups(store.trainer.trainer_id)
                console.log('matchesRes ----------> ', matchesRes)
                matchesCount.value = matchesRes.length

                let winMatchCount = 0

                matchesRes.forEach(match => {
                    if (match.matchType == 'out') {
                        if (match.firstTeamScore < match.secondTeamScore) {
                            winMatchCount += 1
                        }
                    } else {
                        if (match.firstTeamScore > match.secondTeamScore) {
                            winMatchCount += 1
                        }
                    }
                })

                winratePercent.value = ((winMatchCount * 100) / matchesCount.value).toFixed(2)

                trainingCount.value = await getTrainerTrainingsCountInCurrentSeason(store.trainer.trainer_id)

                const currentMonthTrainingsDirectionResponse = await getCurrentMonthTrainingsDirection(store.trainer_groups[0]?.group_id)

                if (!currentMonthTrainingsDirectionResponse) {
                    currentMonthTrainingsDirection.value = []
                } else {
                    currentMonthTrainingsDirection.value = Object.keys(currentMonthTrainingsDirectionResponse).map(key => {
                        return {
                            name: key,
                            value: currentMonthTrainingsDirectionResponse[key]
                        }
                    })
                    console.log('currentMonthTrainingsDirection ------> ', currentMonthTrainingsDirection)
                }


                const currentWeekTrainingsDirectionResponse = await getCurrentWeekTrainingsDirection(store.trainer_groups[0]?.group_id)

                if (!currentWeekTrainingsDirectionResponse) {
                    currentWeekTrainingsDirection.value = []
                } else {
                    currentWeekTrainingsDirection.value = Object.keys(currentWeekTrainingsDirectionResponse).map(key => {
                        return {
                            name: key,
                            value: currentWeekTrainingsDirectionResponse[key]
                        }
                    })
                    console.log('currentWeekTrainingsDirection ------> ', currentWeekTrainingsDirection)
                }
                
                let sumAttendance = 0
                
                for (let i = 0; i < allPlayersCount.value; i++) {
                    sumAttendance += +(await getAttendanceCoeff(allTrainerPlayers.value[i].student_id))
                }

                console.log('sumAttendance ----------> ', sumAttendance)

                averageAttendance.value = sumAttendance / allPlayersCount.value

                fiveNextTrainings.value = store.allTrainings.reverse().slice(0, 5)

                loadingSpinnerFlag.value = false

                window.addEventListener('resize', () => {
                    screenWidth.value = window.innerWidth
                })


                new ResizeObserver(() => chartKey.value++).observe(chartBlock.value)
            })

            return {
                logout,
                loadingSpinnerFlag,
                screenWidth,
                chartData: {
                    data: [1, 2, 3, 4, 4000, 6, 7, 2000, 3200, 1100, 2100, 3900],
                    labels: ['січ', 'лют', 'бер', 'кві', 'тра', 'чер', 'лип', 'сер', 'вер', 'жов', 'лис', 'гру'],
                },
                store,
                formatNumber,
                filteredIncomesByYear,
                dataForYearGroupsIncomes,
                dataForCurrentMonthGroupsIncomes,
                groupAttendanceChartData,
                trainerAllCompletedTrainings,
                completedTrainingsFlag,
                incomesByGroupsYear,
                incomesByGroupsMonth,
                groupAttendanceYear,
                groupAttendanceMonth,
                completedTrainingsYear,
                completedTrainingsMonth,
                getWeekDayShortNameByDate,
                trainerPastMatches,
                trainerFutureMatches,
                futureMatchesMax,
                pastMatchesMax,

                totalDistance,
                averageSpeed,
                speedZone,
                sprintCount,
                speedDistance,
                fiveNextTrainings,

                chartMatchesDates,
                allPlayersCount,
                averageAttendance,
                matchesCount,
                winratePercent,
                trainingCount,
                chartBlock,
                chartKey,
                ratingTable,
                currentMonthTrainingsDirection,
                currentWeekTrainingsDirection,
                timeData: [
                    { name: 'Работа', value: 300 },
                    { name: 'Сон', value: 480 },
                    { name: 'Отдых', value: 120 },
                    { name: 'Спорт', value: 60 }
                ]

            }
        },

        components: {
            BarChart,
            OneLine,
            LineChart,
            PercentLine,
            MultiLineChart,
            WeekTrainerCycle,
            TimePieChart
        }
    }
</script>

<style lang="scss">

.scrollbar::-webkit-scrollbar {
    width: 5px;               /* ширина всей полосы прокрутки */
}

.scrollbar::-webkit-scrollbar-track {
    background: transparent;        /* цвет зоны отслеживания */
}

.scrollbar::-webkit-scrollbar-thumb {
    background-color: #BD9135;    /* цвет бегунка */
    border-radius: 20px;       /* округлось бегунка */ /* отступ вокруг бегунка */
}

</style>